export default __webpack_public_path__ + "static/media/defeat2.d03f7e54.png";